package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp
import com.nonopn.icons.FixedGps
import com.nonopn.icons.SkipNext
import com.nonopn.icons.SkipPrevious
import com.nonopn.icons.ZoomIn
import com.nonopn.icons.ZoomOut
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.pages.main.model.FakeMainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.IMapAction
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.theme.LocalApplicationColorTheme
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalThemeEnvironment
import eu.codlab.compose.widgets.TextNormal
import eu.codlab.platform.Platform
import eu.codlab.platform.currentPlatform

@Composable
fun SelectedDateIntervals(
    modifier: Modifier,
    model: MainScreenModel
) {
    val state by model.states.collectAsState()

    MapOverlayCard(modifier) {
        Row(
            modifier = Modifier.padding(8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(Modifier.weight(1.0f)) { }
            MapOverlayButtonInCard(
                modifier = Modifier.width(24.dp).height(24.dp),
                imageVector = Icons.Default.SkipPrevious,
                contentDescription = "Previous"
            ) {
                model.previousSelectedDate()
            }

            TextNormal(
                text = state.selectedDate.format("HH:mm"),
                fontSize = LocalFontSizes.current.map.activityLightning
            )

            MapOverlayButtonInCard(
                modifier = Modifier.width(24.dp).height(24.dp),
                imageVector = Icons.Default.SkipNext,
                contentDescription = "Next"
            ) {
                model.nextSelectedDate()
            }
            Column(Modifier.weight(1.0f)) { }
        }
    }
}

@Composable
fun MapOverlayButtonInCard(
    modifier: Modifier = Modifier,
    imageVector: ImageVector,
    contentDescription: String,
    onClick: () -> Unit,
) {
    val colors = LocalApplicationColorTheme.current

    Column(modifier.clip(MapButtonsRoundedCorner).clickable(onClick = onClick)) {
        Icon(
            imageVector = imageVector,
            contentDescription = contentDescription,
            tint = colors.fonts.regular
        )
    }
}

@Composable
@HotPreview(widthDp = 250, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 250, heightDp = 50, darkMode = false)
private fun MapButtonsPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        SelectedDateIntervals(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(false)
        )
    }
}
